
const sinsoft_url = "https://sinsoft.com.br";
const site_sinsoft_url = "https://sinsoft.com.br/";

const login_unico_app = "https://solucoes.sinsoft.com.br/login-unico/";
const api_login_unico_url = "https://solucoes.sinsoft.com.br/api/login-unico";



const unico_api = "https://solucoes.sinsoft.com.br/api/consultas-unico";
const enderecos_api = "https://solucoes.sinsoft.com.br/api/enderecos";


//const api_url = "http://localhost:326";
const api_url = "https://solucoes.sinsoft.com.br/api/notificacao-cobranca";



const app_base_url = "/guias-arrecadacao";
const aplicacao = "GUIAS ARRECADAÇÃO";


//const api_pix = "http://localhost:3333/banrisul";

//const api_pix = "http://localhost:3333/caixa";


//const api_pix = "https://solucoes.sinsoft.com.br/api/pix/sicredi";

const api_pix = "https://solucoes.sinsoft.com.br/api/pix/auxPix";


export { app_base_url, sinsoft_url, api_login_unico_url, aplicacao, api_url, unico_api, enderecos_api, login_unico_app, api_pix }